import * as carts from "./carts";
import * as orders from "./orders";
import * as giftOrders from "./gift-orders";
import * as purchases from "./purchases";
import * as reviews from "./reviews";
import * as cashbill from "./cashbill";
import * as ebooks from "./ebooks";

export const shop = {
    ...carts,
    ...orders,
    ...giftOrders,
    ...purchases,
    ...reviews,
    ...cashbill,
    ...ebooks,
}